import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowRight, Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0f172a] text-slate-300 py-16 border-t border-slate-800">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Brand & About */}
          <div className="space-y-6">
            <img
              src="https://isilkoop.com/assets/images/logo/logo-dark.png"
              alt="İSİLKOOP"
              className="h-12 object-contain brightness-0 invert" />

            <p className="text-slate-400 text-sm leading-relaxed font-medium">
              S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi. Bölgede iş dünyasının ihtiyaçlarına yönelik modern ve kapsamlı üretim-ticaret alanları oluşturmayı hedeflemekteyiz.
            </p>
            <div className="flex items-center gap-4 pt-2">
              <a href="https://instagram.com/isilkoop" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-300 hover:bg-pink-600 hover:text-white transition-colors duration-300">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg tracking-wide">Kurumsal</h4>
            <ul className="space-y-3 text-sm font-medium">
              <li>
                <Link to="/kurumsal/hakkimizda" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/kurumsal/misyon-vizyon" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Misyon & Vizyon
                </Link>
              </li>
              <li>
                <Link to="/haberler" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Haberler
                </Link>
              </li>
              <li>
                <Link to="/galeri" className="hover:text-white hover:translate-x-1 transition-all flex items-center gap-2">
                  <ArrowRight size={14} className="text-blue-500" /> Galeri
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold mb-6 text-lg tracking-wide">İletişim Bilgileri</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-blue-900/50 border border-blue-500/20 flex items-center justify-center shrink-0">
                    <MapPin size={18} className="text-blue-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">Merkez Ofis</h5>
                    <p className="text-sm text-slate-400 font-medium">
                      Osb. Mh. Dolapdere Sanayi Sitesi<br />
                      Dolapdere İş Merkezi No: 27 - 4<br />
                      İkitelli / Başakşehir / İstanbul
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-emerald-900/50 border border-emerald-500/20 flex items-center justify-center shrink-0">
                    <MapPin size={18} className="text-emerald-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">Şantiye Adresi</h5>
                    <p className="text-sm text-slate-400 font-medium">
                      Enlem Soğuk Hava Depolama<br />
                      Lojistik ve Gıda Sanayi A.Ş.<br />
                      Gümüşyaka, İstanbul Çorlu Yolu<br />
                      34580 Silivri / İstanbul
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <a href="tel:+902128778918" className="flex items-center gap-4 group hover:opacity-90 transition-opacity">
                  <div className="w-10 h-10 rounded-full bg-slate-800 group-hover:bg-slate-700 flex items-center justify-center shrink-0 transition-colors">
                    <Phone size={18} className="text-blue-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">Telefon</h5>
                    <p className="text-sm text-slate-400 font-medium group-hover:text-blue-300 transition-colors">+90 212 877 89 18</p>
                  </div>
                </a>

                <a href="mailto:info@isilkoop.com" className="flex items-center gap-4 group hover:opacity-90 transition-opacity">
                  <div className="w-10 h-10 rounded-full bg-slate-800 group-hover:bg-slate-700 flex items-center justify-center shrink-0 transition-colors">
                    <Mail size={18} className="text-blue-400" />
                  </div>
                  <div>
                    <h5 className="text-white text-sm font-bold mb-1">E-Posta</h5>
                    <p className="text-sm text-slate-400 font-medium group-hover:text-blue-300 transition-colors">info@isilkoop.com</p>
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 text-center text-sm font-medium text-slate-500 flex flex-col md:flex-row justify-between items-center gap-4">
          <p>© 2026 S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi. Tüm Hakları Saklıdır.</p>
          <p>Designed BiiPixel</p>
        </div>
      </div>
    </footer>);

};

export default Footer;